import { loanActionApi, loanActionApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ACTIONS_ACTION_TYPE = createNamedActions('loanActions', {
  SET_LOAN_ACTIONS_TARGET_TYPE: 'SET_LOAN_ACTIONS_TARGET_TYPE',
  GET_LOAN_ACTIONS: 'GET_LOAN_ACTIONS',
  CREATE_LOAN_ACTION: 'CREATE_LOAN_ACTION',
  EDIT_LOAN_ACTION: 'EDIT_LOAN_ACTION',
  GET_LOAN_ACTION_CRITERIA_SCHEMA: 'GET_LOAN_ACTION_CRITERIA_SCHEMA',
  GET_LOAN_ACTION_POSSIBLE_FIELDS: 'GET_LOAN_ACTION_POSSIBLE_FIELDS',
  GET_INTEGRATION_STUDIO_FIELDS: 'GET_INTEGRATION_STUDIO_FIELDS',
  DISABLE_GLOBAL_ACTION: 'DISABLE_GLOBAL_ACTION',
  ENABLE_GLOBAL_ACTION: 'ENABLE_GLOBAL_ACTION',
  CLONE_GLOBAL_ACTION: 'CLONE_GLOBAL_ACTION',
});

export const setLoanActionsTargetTypeAction = targetType => dispatch =>
  dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.SET_LOAN_ACTIONS_TARGET_TYPE,
    payload: targetType,
  });

const loanActionsSchema = new schema.Entity(
  'data',
  {},
  {
    processStrategy: ({ id, parentId, criteria, companyId, isDisabledForCompany, ...rest }) => ({
      ...rest,
      criteriaId: id,
      parentCriteriaId: parentId || null,
      companyId,
      isDisabledForCompany,
      expression: criteria?.expression,
      userFriendlyExpression: criteria?.userFriendlyExpression,
    }),
  },
);

export const getLoanActionsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanActionApiV2.getLoanActions(params);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTIONS,
    payload: normalize(data, [loanActionsSchema]).entities.data,
  });
});

export const deleteLoanActionAction = catchAsyncActionError(params => async dispatch => {
  await loanActionApiV2.deleteLoanAction(params);

  await dispatch(getLoanActionsAction({ includeGlobalEntities: true }));
});

export const addLoanActionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanActionApiV2.createLoanAction(params);

  const normalizedData = normalize(data, loanActionsSchema);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.CREATE_LOAN_ACTION,
    payload: normalizedData.entities.data[normalizedData.result],
  });
});

export const editLoanActionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanActionApiV2.editLoanAction(params);

  const normalizedData = normalize(data, loanActionsSchema);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.EDIT_LOAN_ACTION,
    payload: normalizedData.entities.data[normalizedData.result],
  });
});

export const getLoanActionCriteriaSchemaAction = catchAsyncActionError(
  ({ targetType } = {}) =>
    async dispatch => {
      const { data } = await loanActionApiV2.getLoanActionsExpressionDefinition({ targetType });

      return dispatch({
        type: LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTION_CRITERIA_SCHEMA,
        payload: data,
        meta: { targetType },
      });
    },
);

export const getLoanActionPossibleFieldsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanActionApi.getLoanActionSchema();

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTION_POSSIBLE_FIELDS,
    payload: data,
  });
});

export const getIntegrationStudioFieldsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanActionApi.getLoanActionSchema(true);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.GET_INTEGRATION_STUDIO_FIELDS,
    payload: data,
  });
});

export const disableGlobalLoanActionAction = catchAsyncActionError(params => async dispatch => {
  await loanActionApiV2.disableGlobalLoanAction(params);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.DISABLE_GLOBAL_ACTION,
    meta: params,
  });
});

export const enableGlobalLoanActionAction = catchAsyncActionError(params => async dispatch => {
  await loanActionApiV2.enableGlobalLoanAction(params);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.ENABLE_GLOBAL_ACTION,
    meta: params,
  });
});

export const cloneGlobalLoanActionAction = catchAsyncActionError(params => async dispatch => {
  await loanActionApiV2.cloneGlobalLoanAction(params);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.CLONE_GLOBAL_ACTION,
    meta: params,
  });
});
